module.exports = __webpack_public_path__ + "static/media/0.6a3e6ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/0.png
// module id = 645
// module chunks = 0